export const Layout = Object.freeze({
	chat: {
		name: 'chat',
		list: 'RecentListContainer',
		content: 'ChatContent'
	},
	createChat: {
		name: 'createChat',
		list: 'RecentListContainer',
		content: 'CreateChatContent'
	},
	notification: {
		name: 'notification',
		list: 'RecentListContainer',
		content: 'NotificationContent'
	},
	openline: {
		name: 'openline',
		list: 'OpenlineListContainer',
		content: 'OpenlineContent'
	},
	conference: {
		name: 'conference',
		list: 'RecentListContainer',
		content: 'ChatContent'
	},
	call: {
		name: 'call',
		list: 'RecentListContainer',
		content: 'ChatContent'
	},
	market: {
		name: 'market',
		list: '',
		content: 'MarketContent'
	}
});